import { GeneralFunction } from 'types/common';

import { InputProps, NotaryDocumentType } from '../types';

export interface INotaryCommission {
  id: string;
  state: string;
  county: string;
  commissionNo: string;
  commissionPeriod: string[];
  thumbnail?: string[];
}

export enum ExtraFieldStatus {
  DANGER = 'danger',
  INFO = 'info',
  DEFAULT = 'default',
  PENDING = 'pending',
  ACTIVE = 'active',
}

export enum DataCardActionType {
  REDIRECT = 'redirect',
  INTERACT = 'interact',
}

export interface IDataCardAction {
  type: DataCardActionType;
  route?: string;
  delete?: (...args: any) => void;
  edit?: (...args: any) => void;
  add?: (...args: any) => void;
}

export interface IFileInput {
  name: string;
  type: string;
  extension: string;
  path: string;
  pipeFrom: string;
  document: string;
  user: string;
}

export interface IMutations {
  mutation: any;
  key: string;
}

export interface IMultipleMutations {
  update: IMutations;
  create: IMutations;
}

export interface IRecordModalType {
  formType?: string;
  record?: any;
  closeModal: () => void;
  userId: string;
  formTitle: string;
  formFields: InputProps[];
  detailsFields: string[];
  updateMutation: IMutations;
  createMutation: IMutations;
  deleteMutation?: any;
  documentType: NotaryDocumentType;
  validationSchema?: any;
  refetchUserData?: GeneralFunction;
}

export interface IRecordFields {
  form: InputProps[];
  details: string[];
}

export interface IRecordFormProps {
  closeModal: () => void;
  record?: Record<string, any>;
  userId: string;
  fields: IRecordFields;
  mutations: IMultipleMutations;
  documentType: NotaryDocumentType;
  validationSchema?: any;
  refetchUserData?: GeneralFunction;
}
